import React, { useState, useEffect } from 'react';
import { getAllTask } from '../Services/masterService';



function ClientDashboard() {
    const [allTasks, setAllTasks] = useState([]);

    const clientStats = [
        { label: "Pending Task", value: "3", icon: "🕒" }, // FaClock
        { label: "Completed Tasks", value: "45", icon: "📦" },    // FaBoxOpen
        { label: "New Requests Today", value: "1", icon: "➕" }, // FaPlus
        { label: "Last Service Date", value: "Oct 5, 2025", icon: "🗓️" }, // FaCalendar
    ];

    // const recentShipments = [
    //     { id: 'SHP-004', status: "Out for Delivery", date: "Oct 12, 2025", location: "Midtown Hub" },
    //     { id: 'SHP-003', status: "In Transit", date: "Oct 10, 2025", location: "Sorting Facility B" },
    //     { id: 'SHP-002', status: "Delivered", date: "Oct 8, 2025", location: "Warehouse A" },
    // ];


    const [taskCounts, setTaskCounts] = useState({
        new_request: 0,
        in_progress: 0,
        completed: 0,
    });

    useEffect(() => {
        const fetchData = async () => {
            const storedUser = localStorage.getItem('user');
            const userInfo = JSON.parse(storedUser)
            try {
                const response = await getAllTask(userInfo.id);
                if (response.status == 1) {
                    setAllTasks(response.data);

                    const counts = {
                        new_request: 0,
                        in_progress: 0,
                        completed: 0,
                    };

                    response.data.forEach(task => {
                        switch (task.status) {
                            case 'NEW_REQUEST':
                                counts.new_request += 1;
                                break;
                            case 'ASSIGNED':
                            case 'ACCEPTED':
                            case 'IN_PROGRESS':
                            case 'COLLECTED':
                            case 'RECEIVED':
                            case 'HANDOVERED':
                                counts.in_progress += 1;
                                break;
                            case 'COMPLETED':
                                counts.completed += 1;
                                break;
                            default:
                                break; // other statuses like CANCELLED or REJECTED are ignored
                        }
                    });

                    setTaskCounts(counts);
                    console.log('taskCounts', taskCounts)
                } else {
                    setAllTasks([]);
                    setTaskCounts({ new_request: 0, in_progress: 0, completed: 0 });
                }
            } catch (error) {
                console.error("Error fetching tasks:", error);
                setAllTasks([]);
                setTaskCounts({ new_request: 0, in_progress: 0, completed: 0 });
            }
        };

        fetchData();
    }, []);


    return (
        <div className="min-h-screen bg-gray-50 font-sans antialiased">
            {/* Navigation Bar */}


            {/* Main Content Wrap */}
            <div className="main-wrap">
                <div className="container">

                    {/* Header and Call to Action */}
                    <header className="flex flex-wrap sm:flex-nowrap justify-between items-center bg-white rounded-lg shadow-xl p-8 mb-10 border-t-4 border-green-600">
                        <div className='pr-0 sm:pr-2 flex-1'>
                            <h1 className="text-3xl font-extrabold text-green-700 mb-2">
                                Your Dashboard
                            </h1>
                            <p className="text-gray-600 text-lg">
                                Quick access to your active requests and tracking details.
                            </p>
                        </div>
                        <button className="bg-green-600 text-white hover:bg-green-700 font-bold py-3 px-8 rounded-lg text-lg shadow-md transform transition duration-300 flex items-center">
                            <span className="text-lg mr-2">➕</span> <a className='text-white text-sm' href="/client-task">New Pickup Request</a>
                        </button>
                    </header>

                    {/* Key Statistics Cards */}
                    <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">

                        {/* Pending Tasks */}
                        <div className="bg-white rounded-lg shadow-lg p-6 text-center border-b-4 border-green-500 transform hover:shadow-xl transition duration-300">
                            <div className="text-5xl mb-3 text-green-600">🕒</div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Pending Task</h3>
                            <p className="text-2xl font-bold text-green-700">
                                {taskCounts.in_progress}
                            </p>
                        </div>

                        {/* Completed Tasks */}
                        <div className="bg-white rounded-lg shadow-lg p-6 text-center border-b-4 border-green-500 transform hover:shadow-xl transition duration-300">
                            <div className="text-5xl mb-3 text-green-600">📦</div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Completed Tasks</h3>
                            <p className="text-2xl font-bold text-green-700">
                                {taskCounts.completed}
                            </p>
                        </div>

                        {/* New Requests Today */}
                        <div className="bg-white rounded-lg shadow-lg p-6 text-center border-b-4 border-green-500 transform hover:shadow-xl transition duration-300">
                            <div className="text-5xl mb-3 text-green-600">➕</div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">New Requests</h3>
                            <p className="text-2xl font-bold text-green-700">
                                {taskCounts.new_request}
                            </p>
                        </div>

                        {/* Last Service Date */}
                        <div className="bg-white rounded-lg shadow-lg p-6 text-center border-b-4 border-green-500 transform hover:shadow-xl transition duration-300">
                            <div className="text-5xl mb-3 text-green-600">🗓️</div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Last Service Date</h3>
                            <p className="text-2xl font-bold text-green-700">
                                {allTasks.length > 0
                                    ? new Date(
                                        allTasks.reduce((latest, task) =>
                                            new Date(task.createdAt) > new Date(latest.createdAt) ? task : latest
                                        ).createdAt
                                    ).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
                                    : "-"
                                }
                            </p>
                        </div>

                    </section>


                    {/* Main Body: Tracking & History */}
                    {/* <section className="grid grid-cols-1 lg:grid-cols-1 gap-8 mb-12">

                        <div className="lg:col-span-2 bg-white rounded-lg shadow-lg p-6 border-t-4 border-green-500">
                            <h3 className="text-2xl font-semibold text-green-700 mb-6 flex items-center">
                                <span className="text-3xl mr-3">🗺️</span> Track Recent Requests <span class="bg-yellow-100 text-yellow-800 text-sm font-medium ml-2 px-2 py-0.5 rounded">Coming Soon</span>

                            </h3>

                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-green-50">
                                        <tr>
                                            {["Shipment ID", "Status", "Last Update", "Location"].map(col => (
                                                <th key={col} className="px-6 py-3 text-left text-xs font-medium text-green-800 uppercase tracking-wider">{col}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {recentShipments.map(shipment => (
                                            <tr key={shipment.id} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{shipment.id}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm">
                                                    <StatusBadge status={shipment.status} />
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{shipment.date}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{shipment.location}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="mt-6 text-right">
                                <a href="#all-tracking" className="text-green-600 hover:underline font-medium">View All Requests &rarr;</a>
                            </div>
                        </div>
                    </section> */}
                </div>
            </div>

            {/* Footer */}
            {/* <footer className="bg-green-800 text-green-200 py-8">
                <div className="container mx-auto px-6 text-center">
                    <p className="mb-4">&copy; {new Date().getFullYear()} ClientConnect. All rights reserved.</p>
                </div>
            </footer> */}
        </div>
    );
}

// Helper component for status badges
const StatusBadge = ({ status }) => {
    const statusText = status?.toUpperCase() || 'UNKNOWN';
    let colorClass = 'bg-gray-100 text-gray-800';
    if (statusText.includes('DELIVERY') || statusText.includes('TRANSIT')) {
        colorClass = 'bg-yellow-100 text-yellow-800';
    } else if (statusText.includes('DELIVERED') || statusText.includes('COMPLETED')) {
        colorClass = 'bg-green-100 text-green-800';
    }

    return <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${colorClass}`}>{statusText}</span>;
};

export default ClientDashboard;